import { atom } from "recoil";
import { ocPersistAtom } from "./persist-atom";

export const ocCurrentUserState = atom({
  key: "currentUser",
  default: {
    contractCode: "",
    employeeCode: "",
    emailAddress: "",
    accessTokenPeriod: 0,
    accessToken: "",
  },
  effects_UNSTABLE: [ocPersistAtom],
});
